export default "__VITE_ASSET__CfHzkHzi__"